
import React, { Fragment, useEffect, useState } from "react";

import {
  Column,
  Table as ReactTable,
  ColumnFiltersState,
  FilterFn,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender
} from '@tanstack/react-table';

import { rankItem } from '@tanstack/match-sorter-utils';
import { Minus, Plus, } from "lucide-react";
import Pagination from "./Components/Pagination";

// Column Filter
const Filter = ({
  column
}: {
  column: Column<any, unknown>;
  table: ReactTable<any>;
}) => {
  const columnFilterValue = column.getFilterValue();

  return (
    <>
      <DebouncedInput
        type="text"
        value={(columnFilterValue ?? '') as string}
        onChange={value => column.setFilterValue(value)}
        placeholder="Search..."
        className="w-36 border shadow rounded"
        list={column.id + 'list'}
      />
      <div className="h-1" />
    </>
  );
};

// Global Filter
const DebouncedInput = ({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);


  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [debounce, onChange, value]);

  return (
    <input {...props} value={value} onChange={e => setValue(e.target.value)} />
  );
};
interface TableContainerProps {
  columns?: any;
  data?: any;
  tableclassName?: any;
  divclassName?: any;
  thclassName?: any;
  trclassName?: any;
  tableClass?: any;
  tdclassName?: any;
  theadclassName?: any;
  tbodyclassName?: any;
  isTfoot?: boolean;
  isSelect?: boolean;
  isBordered?: boolean;
  customPageSize?: number;
  isGlobalFilter?: boolean;
  isPagination: boolean;
  PaginationClassName?: string;
  SearchPlaceholder?: string;
  customnumberfortable?: number;
}

const TableContainer = ({
  columns,
  data,
  tableclassName,
  theadclassName,
  divclassName,
  trclassName,
  thclassName,
  tdclassName,
  tbodyclassName,
  isTfoot,
  isSelect,
  isPagination,
  customPageSize,
  isGlobalFilter,
  PaginationClassName,
  SearchPlaceholder,
  customnumberfortable
}: TableContainerProps) => {

  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [globalFilter, setGlobalFilter] = useState('');

  const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    const itemRank = rankItem(row.getValue(columnId), value);
    addMeta({
      itemRank
    });
    return itemRank.passed;
  };


  const table = useReactTable({
    columns,
    data,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      columnFilters,
      globalFilter,
    },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel()
  });

  const {
    getHeaderGroups,
    getFooterGroups,
    getRowModel,
    getPageOptions,
    setPageIndex,
    setPageSize,
    getState,
    getCanPreviousPage,
    getCanNextPage,
    nextPage,
    previousPage,
  } = table;

  useEffect(() => {
    Number(customPageSize) && setPageSize(Number(customPageSize));
  }, [customPageSize, setPageSize]);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null); // تغییر نوع به string | null

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth <= 768); // تبلت و موبایل
    };

    handleResize(); // هنگام بارگذاری صفحه بررسی شود
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const getVisibleColumns = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 3; // موبایل
      if (window.innerWidth < 1024) return 5; // تبلت
      const numberForTable = customnumberfortable ?? 8;
      return numberForTable // دسکتاپ
    }
    return 3; // پیش‌فرض برای SSR
  };

  const visibleColumns = getVisibleColumns()
  return (
    <Fragment>
      {/* <div className="grid grid-cols-12 lg:grid-cols-12 gap-3">
        <label className="flex items-center gap-2 mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          جست‌وجو:
          <div className="relative">
            <DebouncedInput
              value={globalFilter ?? ''}
              onChange={(value) => {
                if (typeof value === 'string') {
                  setGlobalFilter(value.trim());
                } else {
                  setGlobalFilter(String(value));
                }
              }}
              className="w-64 py-1 pr-3 pl-9 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 transition-all"
              placeholder="جستجو..."
            />
            <span className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-gray-400 dark:text-gray-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 17a6 6 0 100-12 6 6 0 000 12zm10 4l-4.35-4.35"
                />
              </svg>
            </span>
          </div>
        </label>

        {
          isSelect &&
          <div className="flex mt-[-3.4rem]  absolute left-72 justify-end col-span-12  lg:col-span-6">
            <label>سطر
              <select name="basic_tables_length" aria-controls="basic_tables"
                className="px-3 py-2 form-select border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 inline-block w-auto"
                onClick={(event: any) => setPageSize(event.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
        }


      </div> */}

      <div className={divclassName}>
        <table className={tableclassName}>

          <thead className={`${theadclassName} cursor-pointer`}>
            {getHeaderGroups().map((headerGroup: any) => (
              <tr key={headerGroup.id} className={trclassName}>
                {headerGroup.headers.map((header: any, index: number) => (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    className={`${header.column.getCanSort()} ${thclassName} 
            ${index >= getVisibleColumns() ? 'hidden' : ''}`} // ستون‌های مخفی
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {header.isPlaceholder ? null : (
                      <React.Fragment>
                        {flexRender<any>(header.column.columnDef.header, header.getContext())}
                        {({
                          asc: ' ',
                          desc: ' ',
                        } as any)[header.column.getIsSorted() as string] ?? null}
                      </React.Fragment>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className={tbodyclassName}>
            {getRowModel().rows.map((row: any) => (
              <React.Fragment key={row.id}>
                <tr className={trclassName}>
                  {row.getVisibleCells().map((cell: any, index: number) => (
                    <td
                      key={cell.id}
                      className={`${tdclassName} ${index >= getVisibleColumns() ? 'hidden' : ''}`} // ستون‌های مخفی
                    >
                      {index === 0 ? (
                        <div className="flex items-center">
                          {openDropdown === row.id ? (
                            <Minus
                              className="dark:text-white w-4 h-4 flex text-xs border-2 ml-2 dark:border-white text-blue-800 border-blue-800 rounded-full cursor-pointer"
                              onClick={() => setOpenDropdown(null)}
                            />
                          ) : (
                            <Plus
                              className="dark:text-white w-4 h-4 flex text-xs border-2 ml-2 dark:border-white text-blue-800 border-blue-800 rounded-full cursor-pointer"
                              onClick={() => setOpenDropdown(row.id)}
                            />
                          )}
                          {flexRender<any>(cell.column.columnDef.cell, cell.getContext())}
                        </div>
                      ) : (
                        flexRender<any>(cell.column.columnDef.cell, cell.getContext())
                      )}
                    </td>
                  ))}
                </tr>
                {openDropdown === row.id && (
                  <tr >
                    <td colSpan={row.getVisibleCells().length} className="pb-1">
                      <div className="bg-gray-100 dark:bg-gray-800 rounded shadow-md">
                        <div className="block ">
                          {row.getVisibleCells().map((cell: any, index: number) => (
                            <div
                              key={cell.id}
                              className="flex dark:border-blue-900  hover:mr-1 hover:cursor-pointer border-blue-100 border-b flex-col w-full">
                              {index >= getVisibleColumns() && ( // ستون‌های مخفی در دراپ‌دان
                                <div className="flex w-full gap-4">
                                  {/* Header Section */}
                                  <div className="font-bold lg:p-1 pb-1   shrink-0 w-1/3 md:w-1/4">
                                    {cell.column.columnDef.header ? (
                                      typeof cell.column.columnDef.header === 'function'
                                        ? flexRender<any>(cell.column.columnDef.header, cell.getContext())
                                        : cell.column.columnDef.header
                                    ) : null}

                                  </div>
                                  {/* Value Section */}
                                  <div className="flex-1  sm:pt-0   mr-[4.6rem] lg:mr-0 ">
                                    {flexRender<any>(cell.column.columnDef.cell, cell.getContext())}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

              </React.Fragment>
            ))}
          </tbody>



          {isTfoot && <tfoot>
            {
              getFooterGroups()?.map((footer: any, tfKey: number) => (
                <tr key={tfKey}>
                  {
                    footer.headers?.map((tf: any, key: number) => (
                      <th key={key} className="p-3  text-left group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500">
                        {flexRender(
                          tf.column.columnDef.header,
                          tf.getContext()
                        )}
                      </th>
                    ))
                  }
                </tr>
              ))
            }
          </tfoot>}
        </table>

      </div>

      <Pagination
        isPagination={isPagination}
        data={data}
        getState={getState}
        previousPage={previousPage}
        nextPage={nextPage}
        setPageIndex={setPageIndex}
        getPageOptions={getPageOptions}
        getCanPreviousPage={getCanPreviousPage}
        getCanNextPage={getCanNextPage}
        PaginationClassName="your-custom-class"
      />
    </Fragment>
  );
};

export default TableContainer;


